import request from '@/utils/request'

export function getAllCategory(data) {
  return request({
    url: '/Api/brand.DepotCategory/getAllInfo',
    method: 'post',
    data
  })
}

export function saveCategory(data) {
  return request({
    url: '/Api/brand.DepotCategory/save',
    method: 'post',
    data
  })
}

export function getCategoryList(data) {
  return request({
    url: '/Api/brand.DepotCategory/getList',
    method: 'post',
    data
  })
}

export function getRelationChain(data){
	return request({
		url: '/Api/brand.DepotCategory/getRelationChain',
		method: 'post',
		data
	})
}

